<template>
    <div>
        <CompaniesList/>
    </div>
</template>

<script>
import CompaniesList from '../../components/companies/CompaniesList';

export default {
  components: {
    CompaniesList,
  },
};
</script>
